import {text, field} from '@nozbe/watermelondb/decorators';
import {Base} from 'src/models/base';

export class EventCategory extends Base {
  static table = 'event_categories';
  static associations = {
    appointments: {type: 'belongs_to', key: 'event_id'},
  };

  @text('name') name;
  @field('billable') billable;
}
